import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";

import { useAppSelector } from "app/hooks";
import { EMAIL_BRANDING_FEATURE } from "constants/feature-flags";
import { selectCurrentPractice } from "features/auth/auth-slice";
import useUserRoles from "hooks/use-user-roles.hook";

import {
  EMAIL_BRANDING_MERGE_TAG_OPTIONS,
  resolveEmailBranding
} from "./email-branding.utils";

export function useEmailBranding() {
  const practice = useAppSelector(selectCurrentPractice);
  const flags = useFlags();
  const { isAdminOrBusinessOwner } = useUserRoles();
  const storedBranding = practice?.email_branding;
  // The key is absent until the backend ships it, and `CustomModelSerializer` 400s the whole email
  // on an unknown write key: unsupported means every send stays exactly as it was.
  const isSupported =
    Boolean(flags[EMAIL_BRANDING_FEATURE]) && storedBranding !== undefined;
  const branding = useMemo(
    () => resolveEmailBranding({ email_branding: storedBranding }),
    [storedBranding]
  );

  return {
    branding,
    isSupported,
    canEdit: isSupported && isAdminOrBusinessOwner,
    // Null until an admin first saves the settings page. Until then the backend sends a Designer
    // email exactly as designed, so the Designer banner has to say that instead.
    hasSavedSettings: storedBranding != null,
    mergeTagOptions: isSupported ? EMAIL_BRANDING_MERGE_TAG_OPTIONS : []
  };
}
